<template>
  <div>

    <!-- Name -->
    <h4 class="pt-3 pb-1 text-xs font-semibold text-gray-800">
      {{ $t(`mygwf.components.Label.name`) }}
    </h4>
    <base-fieldset>
      <base-input v-model.trim="name" size="sm" />
    </base-fieldset>

    <!-- Module type -->
    <h4 class="pt-3 pb-1 text-xs font-semibold text-gray-800">
      {{ $t(`mygwf.components.Label.module_type`) }}
    </h4>
    <base-fieldset>
      <base-input v-model.trim="module_type" size="sm" />
    </base-fieldset>

    <!-- Module version -->
    <h4 class="pt-3 pb-1 text-xs font-semibold text-gray-800">
      {{ $t(`mygwf.components.Label.module_version`) }}
    </h4>
    <base-fieldset>
      <base-input v-model.trim="module_version" size="sm" />
    </base-fieldset>

    <!-- Company Select -->
    <base-fieldset>
      <CompanySelect :filterArray="keyCompany" size="xs" class="mt-1" />
    </base-fieldset>

  </div>
</template>

<script>
import {
  BaseSelect,
  BaseInput,
  BaseIcon,
  BaseButton,
  BaseButtonIcon,
  BaseFieldset,
} from '@/components/base'
import CompanySelect from '@/components/shared/CompanySelect.vue'
import 'ant-design-vue/lib/popover/style/index.css'
import _isEmpty from 'lodash-es/isEmpty'
import result from 'autoprefixer/data/prefixes'

export default {
  components: {
    BaseSelect,
    BaseInput,
    BaseIcon,
    BaseFieldset,
    BaseButtonIcon,
    BaseButton,
    CompanySelect,
  },

  props: {
    mobile: {
      type: Boolean,
      default: false,
    },
  },

  mounted() {
    this.populateFilters()
  },

  data() {
    return {
      name: this.$route.query.name || '',
      module_type: this.$route.query.module_type || '',
      module_version: this.$route.query.module_version || '',
      keyCompany: [],
    }
  },

  watch: {
    $route(n, o) {
      if (_isEmpty(n.query)) {
        this.reset()
      }
    },
    name(n, o) {
      if (this.mobile) {
        return
      }
      this.$store.dispatch('app/filterProp', {value: n, name: 'name'})
    },
    module_type(n, o) {
      if (this.mobile) {
        return
      }
      this.$store.dispatch('app/filterProp', {value: n, name: 'module_type'})
    },
    module_version(n, o) {
      if (this.mobile) {
        return
      }
      this.$store.dispatch('app/filterProp', {value: n, name: 'module_version'})
    },
    keyCompany(n, o) {
      if (this.mobile) {
        return
      }
      this.$store.dispatch('app/filterProp', {value: n, name: 'company'})
    },
  },

  methods: {

    submit() {
      let filters = {
        value: [this.name, this.module_type, this.module_version, this.keyCompany],
        name: ['name', 'module_type', 'module_version', 'company'],
      }
      this.$store.dispatch('app/filterProp', filters)
    },

    async populateFilters() {
      let query = this.$route.query

      const extractValuesFromQuery = data => {
        let result = []
        if (!data) {
          return result
        }
        if (Array.isArray(data)) {
          result = [...data]
        } else {
          result.push(data)
        }
        return result
      }

      this.keyCompany = extractValuesFromQuery(query.company)
    },

    reset() {
      this.name = '';
      this.module_type ='';
      this.module_version = '';
      this.keyCompany = [];
      this.$router.push({name: 'DeviceProfiles', query: {}})
    },
  },
}
</script>

<style></style>
